import DesUploadSupplierContentInLibraryViewModel from 'viewmodel/DesUploadSupplierContentInLibraryViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesUploadSupplierContentInLibrary extends DesBaseCatalogAcc {
    constructor() {
        super(DesUploadSupplierContentInLibraryViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale','library-id', 'libraryid'];
    }
}

if (!window.customElements.get('des-upload-supplier-content-library')) {
    window.customElements.define('des-upload-supplier-content-library', DesUploadSupplierContentInLibrary);
}
